<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Change Timezone</v-card-title>

    <v-card-text>

        <m-select-timezone
            v-model="timezone"
        />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');



export default {
    data() {
        return {
            dialog: false, 

            timezone: 'America/Phoenix',
        }
    },

    methods: 
    {
        showDialog(profile) 
        {
            this.timezone = profile.employee_account.time_zone;
            this.dialog = true;
        },
        
        onOk()
        {
           this.dialog = false;
           this.$emit('ok', this.timezone);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>